module.exports = __webpack_public_path__ + "h5/img/logo.8bbf5d0f.png";